import PredictionResponseModel from "../../Predictor/Models/Predictions/PredictionResponseModel";
import ProfileModel from "../../Profile/Models/ProfileModel";

export default class PrivateLeaguePredictionModel {
  public predictionId: string = null;
  public predictionModel: PredictionResponseModel = null;
  public profileId: string = null;
  public profileModel: ProfileModel = null;
}
